import React from 'react'
import { InlineWidget } from 'react-calendly'
import { Button } from '~/lib/ui/button'
import { useTranslation } from '~/hooks/useTranslation'
import { useBenefits } from '../../coach_services/BenefitsProvider'
import Modal from '../../_layouts/Modal'
import { Loading } from '~/lib/ui/loading'

const CandidateChangeFormatDialog = () => {
  const {
    resumeReview,
    current_user,
    coach,
    changeReviewFormat,
    setIsReformatting,
    updateCandidateRevision,
    currentCandidateRevision,
    calendlyOpen,
    setCalendlyOpen,
    select,
    isReformattingLoading,
  } = useBenefits()
  const { t } = useTranslation()
  const candidate = current_user
  const [open, setOpen] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)

  const meetingViaCalendly = currentCandidateRevision
    ? currentCandidateRevision?.meeting_via_calendly
    : resumeReview?.meeting_via_calendly
  const getFormatDetails = (meetingViaCalendlyValue) => ({
    currentType: meetingViaCalendlyValue
      ? t('switch_review_format.meeting_based')
      : t('switch_review_format.platform_based'),
    oppositeType: meetingViaCalendlyValue
      ? t('switch_review_format.platform_based')
      : t('switch_review_format.meeting_based'),
    newFormat: meetingViaCalendlyValue ? 'electronic' : 'calendly',
  })

  const meetingOneDetails = getFormatDetails(meetingViaCalendly)
  const meetingTwoDetails = getFormatDetails(
    currentCandidateRevision?.meeting_via_calendly,
  )
  const currentType = updateCandidateRevision
    ? meetingTwoDetails.currentType
    : meetingOneDetails.currentType
  const oppositeType = updateCandidateRevision
    ? meetingTwoDetails.oppositeType
    : meetingOneDetails.oppositeType
  const newFormat = updateCandidateRevision
    ? meetingTwoDetails.newFormat
    : meetingOneDetails.newFormat

  const meetingDuration =
    updateCandidateRevision || current_user?.flex ? 30 : 50

  const handleOpenClick = (e) => {
    e.preventDefault()
    setOpen(true)
  }

  const handleConfirm = async () => {
    setIsLoading(true)
    try {
      if (newFormat === 'calendly') {
        setIsReformatting(true)
        setOpen(false)
        setCalendlyOpen(true)
      } else {
        setIsReformatting(true)
        setOpen(false)
        await changeReviewFormat({ newFormat })
      }
    } finally {
      setIsLoading(false)
    }
  }

  const widgetTitle = updateCandidateRevision
    ? t('switch_review_format.schedule_revision_request')
    : t('switch_review_format.schedule_resume_review')

  return (
    <>
      {isReformattingLoading ? (
        <span className="inline-flex w-fit items-center space-x-2">
          <Loading size={12} />
          <span>{t('switch_review_format.reformatting')}</span>
        </span>
      ) : (
        <a href="#" className="w-fit text-link" onClick={handleOpenClick}>
          {t('service_card.switch_to', { format: oppositeType })}
        </a>
      )}

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title={t('service_card.switch_review_format', { format: oppositeType })}
        size="sm"
        variant={select ? 'primary' : 'secondary'}
        actions={[
          <Button
            key="confirm"
            variant={select ? 'select' : 'coachcta'}
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {t('switch_review_format.confirm')}
          </Button>,
          <Button
            key="cancel"
            variant="ghost"
            onClick={() => setOpen(false)}
            disabled={isLoading}
          >
            {t('service_card.cancel')}
          </Button>,
        ]}
      >
        <div className="flex flex-col space-y-4">
          {t('switch_review_format.current_review_format', {
            format: currentType,
          }) || `The resume review is currently a ${currentType} Review.`}
          <br />
          <br />
          {t('switch_review_format.switch_to_format', {
            format: oppositeType,
          }) || `Would you like to switch to a ${oppositeType} Review?`}
        </div>
      </Modal>

      <Modal
        open={calendlyOpen}
        onClose={() => setCalendlyOpen(false)}
        title={widgetTitle}
        size="lg"
        variant={select ? 'primary' : 'secondary'}
        fullHeight
      >
        <InlineWidget
          url={`${coach?.calendly_link}/${meetingDuration}min`}
          prefill={{
            name: candidate?.candidate_name,
            email: candidate?.candidate_email,
          }}
        />
      </Modal>
    </>
  )
}

export default CandidateChangeFormatDialog
